module.exports = __webpack_public_path__ + "f62df5531594610b914825dbc08e0e52.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/sx.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/sx.svg
// module chunks = 0